import { FC } from 'react';
import './style.scss';
import { data } from './data';

const View: FC<any> = ({ items = data, current = 0 }) => {
    return (
        <div className='zyy-steps'>
            {items.map(({ title, icon, aIcon }: any, index: number) => (
                <div
                    className={['steps-item', index <= current ? 'active' : null].join(' ')}
                    key={index}
                >
                    {items.length === index + 1 ? null : <div className='line'></div>}
                    <div
                        className='icon'
                        style={{
                            backgroundImage: index <= current ? `url(${aIcon})` : `url(${icon})`
                        }}
                    ></div>
                    <div className='text'>{title}</div>
                </div>
            ))}
        </div>
    );
};

export default View;
